import { render } from "./ApplicationDuplicateList.vue?vue&type=template&id=f5b86e60"
import script from "./ApplicationDuplicateList.vue?vue&type=script&lang=js"
export * from "./ApplicationDuplicateList.vue?vue&type=script&lang=js"

import "./ApplicationDuplicateList.vue?vue&type=style&index=0&id=f5b86e60&lang=scss"

import exportComponent from "/app/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.22_vue@3.5.22_typescript@4.1.6__webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__